import { render, staticRenderFns } from "./InspectionListPage.vue?vue&type=template&id=4bcbcd1e&"
import script from "./InspectionListPage.vue?vue&type=script&lang=ts&"
export * from "./InspectionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports